module.exports = __webpack_public_path__ + "img/download-on-the-app-store-fr.2cfdd0a7.svg";